import { datadogRum } from '@datadog/browser-rum';
import { appConfig } from 'config';
const rumAppId = appConfig.datadogRumAppId;
const rumClientToken = appConfig.datadogRumClientToken;
const onboardApiUrl = appConfig.onboardApi;
const apiUrl = appConfig.api;
export const setDDUserData = (userId, accountId, email) => {
    if (rumAppId && rumClientToken) {
        datadogRum.setUser({ id: String(userId), accountId, email });
    }
};
export const initDatadogRum = () => {
    if (rumAppId && rumClientToken && onboardApiUrl && apiUrl) {
        datadogRum.init({
            applicationId: rumAppId,
            clientToken: rumClientToken,
            site: 'datadoghq.com',
            service: 'onboard-client',
            env: appConfig.env,
            version: appConfig.buildId,
            silentMultipleInit: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 0,
            allowedTracingUrls: [onboardApiUrl, apiUrl],
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input'
        });
    }
};
